<template>
  <div>
    <div style="width: 60%;margin: 30px auto 0">
      <h2 style="text-align: center" v-if="$route.query.id">演练维护</h2>
      <h2 v-else style="text-align: center">新建演练</h2>
      <Form :model="drillFrom" :rules="drillRules" ref="drillRefs" :label-width="100">
        <FormItem label="演练地点" prop="drillAddress">
          <Input v-model="drillFrom.drillAddress" placeholder="请输入演练地点"></Input>
        </FormItem>
        <FormItem label="演练日期" prop="drillDate">
          <DatePicker v-model="drillFrom.drillDate" type="date" placeholder="请选择演练日期"></DatePicker>
        </FormItem>
        <FormItem label="演练科目" prop="subject">
          <!--          <Input v-model="drillFrom.subject" placeholder="请输入演练科目"></Input>-->
          <Select v-model="drillFrom.subject">
            <Option v-for="(item,index) in subjectList" :key="index" :label="item.name" :value="item.id"></Option>
          </Select>
        </FormItem>
        <FormItem label="演练方案" prop="programme">
          <Input type="textarea" v-model="drillFrom.programme" placeholder="请输入演练方案"></Input>
        </FormItem>
        <FormItem label="演练评估" prop="estimate">
          <Input type="textarea" v-model="drillFrom.estimate" placeholder="请输入演练评估"></Input>
        </FormItem>
        <FormItem label="演练视频" prop="viewPath">
          <Upload
            :headers="annexHeaders"
            :on-success="viewPathSuccess"
            multiple
            type="drag"
            accept="video/*"
            :show-upload-list="false"
            :action="$uploadUrl+'/api/file/uploadToLocal'">
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>点击或拖曳上传</p>
            </div>
          </Upload>
          <span style="width: 100%;display: inline-block" v-for="(item,index) in drillFrom.viewPath"
                :key="index">{{ item }}<Icon type="ios-close" style="float: right;font-size: 20px"
                                             @click="delViewPath(index)"/></span>
        </FormItem>
        <FormItem label="演练图片" prop="imagePath">
          <Upload
            multiple
            type="drag"
            :headers="annexHeaders"
            :show-upload-list="false"
            :on-success="imagePathSuccess"
            accept="image/*"
            :action="$uploadUrl+'/api/file/uploadToLocal'">
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>点击或拖曳上传</p>
            </div>
          </Upload>
          <span style="width: 100%;display: inline-block" v-for="(item,index) in drillFrom.imagePath"
                :key="index">{{ item }} <Icon type="ios-close" style="float: right;font-size: 20px"
                                              @click="delImagePath(index)"/></span>
        </FormItem>
      </Form>
      <div style="text-align: center;margin-top: 20px">
        <div v-if="currentId">
          <Button type="primary" @click="editDrill()" :loading="editLoading">修改</Button>
        </div>
        <div v-else>
          <Button type="primary" @click="createNewDrill(0)" :loading="draftLoading">草稿</Button>
          <Button type="primary" style="margin-left: 20px" @click="createNewDrill(1)" :loading="subLoading">提交
          </Button>
          <Button style="margin-left: 20px" @click="resetForm('drillRefs')">重置</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      countyList: [],
      draftLoading: false,
      subLoading: false,
      editLoading: false,
      annexHeaders: {Authorization: localStorage.getItem('token')},
      drillFrom: {
        drillAddress: '', // 演练地点
        drillDate: '', // 演练日期
        subject: '', // 演练科目
        programme: '', // 演练方案
        estimate: '', // 演练评估
        viewPath: [], // 演练视频
        imagePath: [] // 演练图片
      },
      drillRules: {
        drillAddress: [
          {required: true, message: '请输入演练地点', trigger: 'blur'}
        ],
        drillDate: [
          {required: true, message: '请输入演练日期', trigger: 'blur', type: 'date'}
        ],
        subject: [
          {required: true, message: '请输入演练科目', trigger: 'blur'}
        ],
        programme: [
          {required: true, message: '请输入演练方案', trigger: 'blur'}
        ],
        estimate: [
          {required: true, message: '请输入演练评估', trigger: 'blur'}
        ],
      },
      subjectList: [],
      currentId: null
    }
  },
  mounted() {
    this.getSubjectList()
    this.currentId = this.$route.query.id
    if (this.currentId) {
      this.getDrillDetail()
    }
  },
  methods: {
    // 删除
    delViewPath(index) {
      this.drillFrom.viewPath.splice(index, 1)
    },
    delImagePath(index) {
      this.drillFrom.imagePath.splice(index, 1)
    },
    // 获取科目列表
    getSubjectList() {
      this.$http.get('/api/drillSubjects').then(res => {
        if (res.status === 200) {
          this.subjectList = res.data.data
        }
      })
    },
    // 获取演练详情
    getDrillDetail() {
      this.$http.get(`/api/emergencyDrills/${this.currentId}`).then(res => {
        if (res.status === 200) {
          this.drillFrom = res.data
          this.drillFrom.viewPath = this.drillFrom.viewPath.split(',')
          this.drillFrom.imagePath = this.drillFrom.imagePath.split(',')
        }
      })
    },
    viewPathSuccess(response, file, fileList) {
      let fileInfo = response.split(', ')
      let filePath = fileInfo[3].slice(0, -2)
      this.drillFrom.viewPath.push(filePath.split('=')[1])
    },
    imagePathSuccess(response, file, fileList) {
      let fileInfo = response.split(', ')
      let filePath = fileInfo[3].slice(0, -2)
      this.drillFrom.imagePath.push(filePath.split('=')[1])
    },
    editDrill() {
      this.$refs.drillRefs.validate((valid) => {
        this.editLoading = true
        if (valid) {
          let request = {
            ...this.drillFrom,
            id: this.currentId,
            viewPath: this.drillFrom.viewPath.join(','),
            imagePath: this.drillFrom.imagePath.join(',')
          }
          this.$http.put('/api/emergencyDrills', request).then(res => {
            if (res.status === 200) {
              this.editLoading = false
              this.$Message.success('演练修改成功')
              this.$router.push('/EmergencyManagements/emergencyDrill')
            }
          })
        }
      })
    },
    createNewDrill(status) {
      this.$refs.drillRefs.validate((valid) => {
        if (valid) {
          if (status === 0) {
            this.draftLoading = true
          } else {
            this.subLoading = true
          }
          let request = {
            ...this.drillFrom,
            status,
            viewPath: this.drillFrom.viewPath.join(','),
            imagePath: this.drillFrom.imagePath.join(',')
          }
          console.log(request)
          this.$http.post('/api/emergencyDrills', request).then(res => {
            if (res.status === 201) {
              this.$Message.success('演练添加成功')
              if (status === 0) {
                this.draftLoading = false
              } else {
                this.subLoading = false
              }
              this.$router.push('/EmergencyManagements/emergencyDrill')
            }
          })
        } else {
          this.$Message.error('请检查表单内容')
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style scoped lang="less"></style>
